import { createFileRoute, redirect } from "@tanstack/react-router";

// Founder messages merged into the single contact form. Old messages kept.
export const Route = createFileRoute("/write-to-founder")({
  beforeLoad: () => {
    throw redirect({ to: "/contact", replace: true, statusCode: 301 });
  },
});
